// src/hooks/cities/useRestoreCity.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { restoreCity } from "../../api/apiCities";
import parseError from "../../utils/parseError";

const useRestoreCity = () => {
    const queryClient = useQueryClient();

    const { mutate: restoreCityMutate, isPending } = useMutation({
        mutationFn: restoreCity,
        onSuccess: (res) => {
            const message = res?.message || "City restored successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["cities"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to restore city");
        },
    });

    return { restoreCityMutate, isPending };
};

export default useRestoreCity;